import React from "react";

function MapIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 20 18"
    >
      <path
        fill="currentColor"
        d="M7 4L0 .5v13.236l7 3.5 6-3 7 3.5V4.5L13 1 7 4zm6 8.118l-6 3v-9l6-3v9z"
      ></path>
    </svg>
  );
}

export default MapIcon;
